import { Address } from './../../../../../core/domain/models/dawa.model';
import { Mapper } from "../../../../../core/base";
import { AdresseWebEntity } from "./adresse-web-entity";

export class AdresseWebRepositoryMapper extends Mapper<AdresseWebEntity, Address> {
  // Address from dawa server
  mapFrom(param: AdresseWebEntity): Address {
    return {
        id: param.id,
        status: param.status,
        darstatus: param.darstatus,
        roadCode: param.vejkode,
        streetName: param.vejnavn,
        addressingStreetName: param.adresseringsvejnavn,
        country: "Denmark",
        houseNumber: param.husnr,
        floor: param.etage,
        door: param.dør,
        additionalStreetName: param.supplerendebynavn,
        postnr: param.postnr,
        postalName: param.postnrnavn,
        mainRecipientRecordNumber: param.stormodtagerpostnr,
        majorRecipientRecordName: param.stormodtagerpostnrnavn,
        municipalCode: param.kommunekode,
        accessAddress: param.adgangsadresseid,
        x: param.x,
        y: param.y,
        href: param.href,
        litra: extractAlphabeticCharacter(param.husnr)
      
    };
  }

  mapTo(param: Address): AdresseWebEntity {
    return {
        id: param.id,
        status: param.status,
        darstatus: param.darstatus,
        vejkode: param.roadCode,
        vejnavn: param.streetName,
        adresseringsvejnavn: param.addressingStreetName,
        land: param.country,
        husnr: param.houseNumber,
        etage: param.floor!,
        dør: param.door!,
        supplerendebynavn: param.additionalStreetName,
        postnr: param.postnr,
        postnrnavn: param.postalName,
        stormodtagerpostnr: param.mainRecipientRecordNumber,
        stormodtagerpostnrnavn: param.majorRecipientRecordName,
        kommunekode: param.municipalCode,
        adgangsadresseid: param.accessAddress,
        x: param.x,
        y: param.y,
        href: param.href
    };
  }
}
function  extractAlphabeticCharacter(input: string): string | undefined {
  const match = input.match(/[A-Za-z]/);

  if (match) {
    return match[0];
  } else {
    return undefined;
  }
}